import '@/assets/styles/app.scss'
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import '@/plugins'
import '@/components'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    ...App,
    template: '<App/>'
})

/**
 * Chat.hu initialized ...
 * 
 * TODO:
 *   - extra fields
*/



// WEBPACK FOOTER //
// ./src/main.js